const dateToMonth = (date: Date) => date.toLocaleString('en-US', { month: 'short' })

const dateToLocal = (date: Date) => date.toLocaleDateString('en-CA')

export { dateToMonth, dateToLocal }
